export enum RefundStatus {
    Pending = 'pending',
    Initiated = 'initiated',
    Succeeded = 'succeeded',
    Failed = 'failed',
}
